export function getExamSettings(exam) {
  const settings = exam?.settings || {};

  return {
    randomizeQuestions: Boolean(settings.randomizeQuestions),
    randomizeOptions: Boolean(settings.randomizeOptions),
    showResultsAfterExam: Boolean(settings.showResultsAfterExam),
    showCorrectAnswers: Boolean(settings.showCorrectAnswers),
    allowReviewAfterFinish: Boolean(settings.allowReviewAfterFinish),
  };
}

function hashSeed(value) {
  let hash = 2166136261;

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }

  return hash >>> 0;
}

function createRng(seed) {
  let state = seed || 1;

  return function next() {
    state = (Math.imul(state, 1664525) + 1013904223) >>> 0;
    return state / 4294967296;
  };
}

export function shuffleWithSeed(items, seed) {
  const list = [...items];
  const rng = createRng(hashSeed(String(seed)));

  for (let index = list.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(rng() * (index + 1));
    [list[index], list[swapIndex]] = [list[swapIndex], list[index]];
  }

  return list;
}

export function prepareExamQuestions(exam) {
  const settings = getExamSettings(exam);
  const seedBase = exam?.id || 'exam';
  const sortedQuestions = [...(exam?.questions || [])].sort(
    (left, right) => (left.sortOrder || 0) - (right.sortOrder || 0)
  );
  const questions = settings.randomizeQuestions
    ? shuffleWithSeed(sortedQuestions, `${seedBase}:questions`)
    : sortedQuestions;

  if (!settings.randomizeOptions) {
    return questions;
  }

  return questions.map((question) => {
    if (!question.options?.length) {
      return question;
    }

    return {
      ...question,
      options: shuffleWithSeed(question.options, `${seedBase}:options:${question.id}`),
    };
  });
}

export function getExamSubmissionScore(exam) {
  const submission = exam?.submission;

  if (!submission) {
    return null;
  }

  const score = submission.totalScore ?? submission.score ?? submission.obtainedScore;

  if (score == null || score === '') {
    return null;
  }

  return score;
}

export function canShowExamResults(exam) {
  return getExamSettings(exam).showResultsAfterExam;
}

export function canReviewExamAfterFinish(exam) {
  return getExamSettings(exam).allowReviewAfterFinish;
}

export function canOpenSubmittedExam(exam) {
  const settings = getExamSettings(exam);

  return (
    settings.allowReviewAfterFinish ||
    settings.showResultsAfterExam ||
    settings.showCorrectAnswers
  );
}
